// -------------------------------
// SALARY AUTO PROCESS INTERFACES
// -------------------------------
export interface PendingAutoSalary {
    year?: number;
    month?: string; // Month name (March, April, etc.)
    confirm?: boolean;
}

export interface PendingDeleteAutoSalary {
    awaitingInfo?: boolean;
}
export const startCreateAutoSalaryFlow = (
    setPending: (data: PendingAutoSalary | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    setPending({});
    pushAIChat("Sure! For which year should I process salary?");
    speak("For which year should I process salary?");
};
export const processPendingAutoSalary = (
    text: string,
    pending: PendingAutoSalary,
    setPending: (data: PendingAutoSalary | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {

    // STEP 1 — YEAR
    if (!pending.year) {
        const year = Number(text);
        if (isNaN(year) || year < 2000) {
            pushAIChat("Please provide a valid year.");
            speak("Please provide a valid year.");
            return;
        }

        setPending({ ...pending, year });
        pushAIChat("Which month should I process salary for?");
        speak("Which month should I process salary for?");
        return;
    }

    // STEP 2 — MONTH
    if (!pending.month) {
        const monthText = text.trim();
        const monthIndex = new Date(`${monthText} 1`).getMonth();

        if (isNaN(monthIndex)) {
            pushAIChat("Please provide a valid month name.");
            speak("Please provide a valid month name.");
            return;
        }

        setPending({ ...pending, month: monthText });
        pushAIChat(
            `You want to process salary for ${monthText} ${pending.year}. Should I proceed?`
        );
        speak("Should I proceed?");
        return;
    }

    // STEP 3 — CONFIRMATION
    if (!pending.confirm) {
        if (text.toLowerCase().includes("yes")) {
            const finalPayload = {
                year: pending.year,
                month: pending.month
            };

            pushAIChat(
                `Processing salary for ${pending.month} ${pending.year}...`
            );
            speak("Processing salary.");

            // 🔥 GLOBAL MASTER EVENT
            window.dispatchEvent(
                new CustomEvent("ai-process-salary-request", {
                    detail: finalPayload
                })
            );

            setPending(null);
            return;
        }

        if (text.toLowerCase().includes("no")) {
            pushAIChat("Okay, salary processing cancelled.");
            speak("Salary processing cancelled.");
            setPending(null);
            return;
        }

        pushAIChat("Please confirm with Yes or No.");
        speak("Please say yes or no.");
        return;
    }
};
export const startDeleteAutoSalaryFlow = (
    setPendingDelete: (data: PendingDeleteAutoSalary | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    setPendingDelete({ awaitingInfo: true });
    pushAIChat("Please provide month and year to delete processed salary.");
    speak("Please provide month and year.");
};
export const processPendingDeleteAutoSalary = (
    text: string,
    pending: PendingDeleteAutoSalary,
    setPendingDelete: (data: PendingDeleteAutoSalary | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    if (!pending.awaitingInfo) return;

    // Expected: "March 2025"
    const parts = text.trim().split(" ");
    if (parts.length < 2) {
        pushAIChat("Please provide both month and year.");
        speak("Please provide both month and year.");
        return;
    }

    const year = Number(parts.pop());
    const monthText = parts.join(" ");
    const month = new Date(`${monthText} 1`).getMonth() + 1;

    if (isNaN(year) || month < 1 || month > 12) {
        pushAIChat("Invalid month or year.");
        speak("Invalid month or year.");
        return;
    }

    pushAIChat(`Deleting salary records for ${monthText} ${year}...`);
    speak("Deleting salary records.");

    window.dispatchEvent(
        new CustomEvent("ai-delete-salary-process", {
            detail: { year, month }
        })
    );

    setPendingDelete(null);
};
